export var convertActionToDisplay = function convertActionToDisplay(action) {
  if (action === '10') {
    return 'Viewer';
  } else if (action === '20') {
    return 'Editor';
  }
};

// Convert dispaly action to casper format
export var convertActionToCasper = function convertActionToCasper(action) {
  if (action === 'Viewer') {
    return '10';
  } else if (action === 'Editor') {
    return '20';
  }
};
export var actionIsViewer = function actionIsViewer(action) {
  return action === '10' || action === 10;
};
export var actionIsEditor = function actionIsEditor(action) {
  return action === '20' || action === 20;
};